export default __webpack_public_path__ + "static/media/gecko.5d38b6bd.png";